<template>
  <div id="app">
    <router-view/>
    <Footer/>
  </div>
</template>
<style lang="scss">
@import "./assets/css/common.scss"; /*引入公共样式*/

#app {
  font-family: "PingFangSC-Regular", "Source Han Sans CN", "Microsoft Yahei",
    Arial, sans-serif;
  min-width: 1100px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color3;
  a {
    text-decoration: none;
    outline: none;
  }
}
</style>
<script>
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Footer
  }
};
</script>
